module.exports = __webpack_public_path__ + "img/ico059.eb8a2120.svg";